export const moreIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="9" height="14" fill="none">
    <path
      stroke="#F28741"
      strokeLinecap="round"
      strokeWidth="2"
      d="m1 13 6-6-6-6"
    />
  </svg>
);
